import { colors } from '@mui/material';

export default {
  styleOverrides: {
    root: {
      backgroundColor: colors.grey[50],
      '& .MuiTableCell-head': {
        backgroundColor: colors.grey[50],
        fontWeight: 600,
        fontSize: '0.875rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }
    }
  }
};
